import ClubCreate from '../club/ClubCreate'
import ClubView from '../club/ClubView'
import Home from '../Home'
import BranchView from '../branch/BranchView'
import ClubEdit from '../club/ClubEdit'
import SaleView from '../sale/SaleView'
import SaleEdit from '../sale/SaleEdit'
import ProductCreate from '../product/ProductCreate'
import CostAdjustmentCreate from '../costAdjustment/CostAdjustmentCreate'
import BranchCreate from '../branch/BranchCreate'
import BranchEdit from '../branch/BranchEdit'
import ProductEdit from '../product/ProductEdit'
import ProductView from '../product/ProductView'
import LocationView from '../location/LocationView'
import LocationEdit from '../location/LocationEdit'
import CostAdjustmentView from '../costAdjustment/CostAdjustmentView'
import CostAdjustmentEdit from '../costAdjustment/CostAdjustmentEdit'
import LocationCreate from '../location/LocationCreate'
import GiftEdit from '../gift/GiftEdit'
import ProductHistoryEdit from '../productHistory/ProductHistoryEdit'
import GiftView from '../gift/GiftView'
import ClubEnrollment from '../club/ClubEnrollment'
import UserView from '../users/userView'
import UserCreate from '../users/userCreate'
import UserEdit from '../users/userEdit'
import Report from '../reports/Report'
import PromoCodeCreate from '../promoCode/PromoCodeCreate'
import PromoCodeEdit from '../promoCode/PromoCodeEdit'
import PromoCodeVIew from '../promoCode/PromoCodeView'
import RedemptionCodesView from '../redemptionCode/RedemptionCodesView'
import RedemptionCodesCreate from '../redemptionCode/RedemptionCodesCreate'

export default {
  Home: {
    component: Home,
    path: '/secure/home',
  },
  RedemptionCodesView: {
    component: RedemptionCodesView,
    path: '/secure/redemptionCodes',
  },
  RedemptionCodesEdit: {
    component: RedemptionCodesCreate,
    path: '/secure/redemptionCodesEdit/:id',
  },
  RedemptionCodesCreate: {
    component: RedemptionCodesCreate,
    path: '/secure/redemptionCodesCreate',
  },
  ClubView: {
    component: ClubView,
    path: '/secure/clubs',
  },
  ClubEdit: {
    component: ClubEdit,
    path: '/secure/clubEdit/:id',
  },
  ClubCreate: {
    component: ClubCreate,
    path: '/secure/clubCreate',
  },
  BranchCreate: {
    component: BranchCreate,
    path: '/secure/branchCreate',
  },
  BranchView: {
    component: BranchView,
    path: '/secure/branches',
  },
  BranchEdit: {
    component: BranchEdit,
    path: '/secure/branchEdit/:id',
  },
  PromoCodeView: {
    component: PromoCodeVIew,
    path: '/secure/promoCodes',
  },
  PromoCodeCreate: {
    component: PromoCodeCreate,
    path: '/secure/promoCodeCreate',
  },
  PromoCodeEdit: {
    component: PromoCodeEdit,
    path: '/secure/promoCodeEdit/:promoCodeId',
  },
  ProductView: {
    component: ProductView,
    path: '/secure/products',
  },
  ProductCreate: {
    component: ProductCreate,
    path: '/secure/productCreate',
  },
  ProductEdit: {
    component: ProductEdit,
    path: '/secure/productEdit/:productId',
  },
  CostAdjustmentView: {
    component: CostAdjustmentView,
    path: '/secure/productEdit/costAdjustments/:productId',
  },
  CostAdjustmentCreate: {
    component: CostAdjustmentCreate,
    path: '/secure/costAdjustmentCreate/:productId',
  },
  CostAdjustmentEdit: {
    component: CostAdjustmentEdit,
    path: '/secure/costAdjustmentEdit/:productId/:costAdjustmentId',
  },
  LocationView: {
    component: LocationView,
    path: '/secure/locations',
  },
  LocationEdit: {
    component: LocationEdit,
    path: '/secure/locationEdit/:branchId/:locationId',
  },
  LocationCreate: {
    component: LocationCreate,
    path: '/secure/locationCreate',
  },
  SaleView: {
    component: SaleView,
    path: '/secure/sales',
  },
  SaleEdit: {
    component: SaleEdit,
    path: '/secure/saleEdit/:saleId',
  },
  SaleReport: {
    component: Report,
    path: '/secure/sale/report',
  },
  GiftReport: {
    component: Report,
    path: '/secure/gift/report',
  },
  ClubEnrollment: {
    component: ClubEnrollment,
    path: '/secure/enrollment',
  },
  GiftView: {
    component: GiftView,
    path: '/secure/gifts',
  },
  GiftEdit: {
    component: GiftEdit,
    path: '/secure/giftEdit/:id',
  },
  ProductHistoryEdit: {
    component: ProductHistoryEdit,
    path: '/secure/productHistoryEdit/:id',
  },
  UserView: {
    component: UserView,
    path: '/secure/users',
  },
  UserCreate: {
    component: UserCreate,
    path: '/secure/userCreate',
  },
  UserEdit: {
    component: UserEdit,
    path: '/secure/userEdit/:id',
  },
  RedemptionReport: {
      component: Report,
      path: '/secure/redemptions/report',
  },
}
